'use strict';
/* eslint-env browser */

var _slicedToArray = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _assertThisInitialized = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/assertThisInitialized");

var _inherits = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _createSuper = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createSuper");

var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _objectSpread = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _require = require('multiaddr'),
    Multiaddr = _require.Multiaddr;

var _require2 = require('ipfs-utils/src/env'),
    isBrowser = _require2.isBrowser,
    isWebWorker = _require2.isWebWorker,
    isNode = _require2.isNode;

var _require3 = require('parse-duration'),
    parseDuration = _require3.default;

var log = require('debug')('ipfs-http-client:lib:error-handler');

var HTTP = require('ipfs-utils/src/http');

var merge = require('merge-options');

var toUrlString = require('ipfs-core-utils/src/to-url-string');

var http = require('http');

var https = require('https');

var DEFAULT_PROTOCOL = isBrowser || isWebWorker ? location.protocol : 'http';
var DEFAULT_HOST = isBrowser || isWebWorker ? location.hostname : 'localhost';
var DEFAULT_PORT = isBrowser || isWebWorker ? location.port : '5001';
/**
 * @typedef {import('ipfs-utils/src/types').HTTPOptions} HTTPOptions
 * @typedef {import('../types').Options} Options
 */

/**
 * @param {Options|URL|Multiaddr|string} [options]
 * @returns {Options}
 */

var normalizeOptions = function normalizeOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var url;
  /** @type {Options} */

  var opts = {};
  var agent;

  if (typeof options === 'string' || Multiaddr.isMultiaddr(options)) {
    url = new URL(toUrlString(options));
  } else if (options instanceof URL) {
    url = options;
  } else if (typeof options.url === 'string' || Multiaddr.isMultiaddr(options.url)) {
    url = new URL(toUrlString(options.url));
    opts = options;
  } else if (options.url instanceof URL) {
    url = options.url;
    opts = options;
  } else {
    opts = options || {};
    var protocol = (opts.protocol || DEFAULT_PROTOCOL).replace(':', '');
    var host = (opts.host || DEFAULT_HOST).split(':')[0];
    var port = opts.port || DEFAULT_PORT;
    url = new URL("".concat(protocol, "://").concat(host, ":").concat(port));
  }

  if (opts.apiPath) {
    url.pathname = opts.apiPath;
  } else if (url.pathname === '/' || url.pathname === undefined) {
    url.pathname = 'api/v0';
  }

  if (isNode) {
    var Agent = url.protocol.startsWith('https') ? https.Agent : http.Agent;
    agent = opts.agent || new Agent({
      keepAlive: true,
      // Similar to browsers which limit connections to six per host
      maxSockets: 6
    });
  }

  return _objectSpread(_objectSpread({}, opts), {}, {
    host: url.host,
    protocol: url.protocol.replace(':', ''),
    port: Number(url.port),
    apiPath: url.pathname,
    url: url,
    agent: agent
  });
};
/**
 * @param {Response} response
 */


var errorHandler = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    var msg, data, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (!(response.headers.get('Content-Type') || '').startsWith('application/json')) {
              _context.next = 9;
              break;
            }

            _context.next = 4;
            return response.json();

          case 4:
            data = _context.sent;
            log(data);
            msg = data.Message || data.message;
            _context.next = 12;
            break;

          case 9:
            _context.next = 11;
            return response.text();

          case 11:
            msg = _context.sent;

          case 12:
            _context.next = 18;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            log('Failed to parse error response', _context.t0); // Failed to extract/parse error message from response

            msg = _context.t0.message;

          case 18:
            /** @type {Error} */
            error = new HTTP.HTTPError(response); // This is what go-ipfs returns where there's a timeout

            if (msg && msg.includes('context deadline exceeded')) {
              error = new HTTP.TimeoutError('Request timed out');
            } // This also gets returned


            if (msg && msg.includes('request timed out')) {
              error = new HTTP.TimeoutError('Request timed out');
            } // If we managed to extract a message from the response, use it


            if (msg) {
              error.message = msg;
            }

            throw error;

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 14]]);
  }));

  return function errorHandler(_x) {
    return _ref.apply(this, arguments);
  };
}();

var KEBAB_REGEX = /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g;
/**
 * @param {string} str
 */

var kebabCase = function kebabCase(str) {
  return str.replace(KEBAB_REGEX, function (match) {
    return '-' + match.toLowerCase();
  });
};
/**
 * @param {string | number} value
 */


var parseTimeout = function parseTimeout(value) {
  return typeof value === 'string' ? parseDuration(value) : value;
};

var Client = /*#__PURE__*/function (_HTTP) {
  _inherits(Client, _HTTP);

  var _super = _createSuper(Client);

  /**
   * @param {Options|URL|Multiaddr|string} [options]
   */
  function Client() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Client);

    var opts = normalizeOptions(options);
    _this = _super.call(this, {
      timeout: parseTimeout(opts.timeout || 0) || 60000 * 20,
      headers: opts.headers,
      base: "".concat(opts.url),
      handleError: errorHandler,
      transformSearchParams: function transformSearchParams(search) {
        var out = new URLSearchParams(); // @ts-ignore https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams

        var _iterator = _createForOfIteratorHelper(search),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                key = _step$value[0],
                value = _step$value[1];

            if (value !== 'undefined' && value !== 'null' && key !== 'signal') {
              out.append(kebabCase(key), value);
            } // @ts-ignore server timeouts are strings


            if (key === 'timeout' && !isNaN(value)) {
              out.append(kebabCase(key), value);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return out;
      },
      // @ts-ignore this can be a https agent or a http agent
      agent: opts.agent
    }); // @ts-ignore - cannot delete no-optional fields

    delete _this.get; // @ts-ignore - cannot delete no-optional fields

    delete _this.put; // @ts-ignore - cannot delete no-optional fields

    delete _this.delete; // @ts-ignore - cannot delete no-optional fields

    delete _this.options;
    var fetch = _this.fetch;
    /**
     * @param {string | Request} resource
     * @param {HTTPOptions} options
     */

    _this.fetch = function (resource) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof resource === 'string' && !resource.startsWith('/')) {
        resource = "".concat(opts.url, "/").concat(resource);
      }

      return fetch.call(_assertThisInitialized(_this), resource, merge(options, {
        method: 'POST'
      }));
    };

    return _this;
  }

  return Client;
}(HTTP);

Client.errorHandler = errorHandler;
module.exports = Client;